export default {
    label_task:{
        en:"Dealers Sales vs Target Report",
        bn:'Variety Report'
    },
    label_achievement :{
        en:"Achievement(%)",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_from:{
        en:"Sales From",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_to:{
        en:"Sales To",
        bn:'ব্যবহারকারীরা'
    },
    label_target:{
        en:"Target",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_net:{
        en:"Net Sales",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_gross:{
        en:"Gross Sales",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_cancel:{
        en:"Canceled Sales",
        bn:'ব্যবহারকারীরা'
    },
    label_difference:{
        en:"Difference",
        bn:'ব্যবহারকারীরা'
    },

}